// tippy CSSs
import 'tippy.js/themes/light.css';
import 'tippy.js/themes/light-border.css';
import 'tippy.js/themes/translucent.css';

// Global tippy styles
import 'tippy.js/dist/tippy.css';

// Override tippy z-index to appear above Bootstrap navbar
const style = document.createElement('style');
style.textContent = `
  .tippy-box {
    z-index: 1050 !important;
  }
`;
document.head.appendChild(style);
